import { SMBInfoGatheringCta as SMBInfoGatheringCtaClient } from './SMBInfoGatheringCtaClient';
import type { SMBInfoGatheringCtaProps } from './types';

export function SMBInfoGatheringCta({ props, type, version }: SMBInfoGatheringCtaProps) {
  return <SMBInfoGatheringCtaClient props={props} type={type} version={version} />;
}
